import { Link, useLocation } from "react-router-dom";
import { Clock, Lock, Crown } from "lucide-react";
import { useApp } from "../context/AppContext";
import { useAuth } from "../context/AuthContext";

export function PlanBanner() {
  const { t } = useApp();
  const { user, role } = useAuth();
  const loc = useLocation();
  const sub = user?.subscription;
  if (role !== "parent" || !sub || sub.plan === "enterprise" || loc.pathname === "/account/plan") return null;
  const soon = sub.status !== "expired" && sub.days_left <= 7;
  if (!sub.locked && !soon) return null;
  const msg = sub.locked ? t("planBannerExpired") : t(sub.status === "active" ? "planBannerActive" : "planBannerTrial").replace("{n}", sub.days_left);
  const Icon = sub.locked ? Lock : sub.status === "active" ? Crown : Clock;
  return (
    <div data-testid="plan-banner" className={`mb-5 flex flex-wrap items-center gap-3 rounded-2xl px-4 py-3 border font-semibold text-sm ${sub.locked ? "bg-orange-50 border-orange-200 text-orange-900" : "bg-blue-50 border-blue-200 text-[#002FC4]"}`}>
      <Icon size={18} className="shrink-0" /> <span className="flex-1">{msg}</span>
      <Link to="/account/plan" data-testid="plan-banner-cta" className={`inline-flex items-center rounded-xl px-3.5 py-1.5 text-white ${sub.locked ? "bg-[#FF8A00]" : "bg-[#0038EB]"}`}>{t("planBannerCta")}</Link>
    </div>
  );
}
